import React from "react";
import { TextField, Button } from '@mui/material'
import withModal from '../../Modal'

const AddCostModal = (props:any) => {
    return (
        <div className='modal' style={{ display: 'block', zIndex: 1200, position: 'fixed', top: '20%' }} role='dialog'>
        <div className='modal-dialog'>
            <div className='modal-content'>
                <div className='modal-body'>
                    <div className='row'>
                        <div className='col-lg-6 col-md-6 col-sm-6 col-xs-6'>
                            <TextField
                                label='Bezeichnung'
                                name='expenditureDescription'
                                error={!props.validRequiredFields.expenditureDescription}
                                value={props.newCost.expenditureDescription}
                                onChange={(e:any) => props.change(e)}
                             />
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-6 col-xs-6'>
                            <TextField 
                                label='Ausgaben'
                                name='expenditureAmount'
                                error={!props.validRequiredFields.expenditureAmount}
                                value={typeof props.newCost.expenditureAmount != 'undefined' ? props.newCost.expenditureAmount.toString().replace('.',',') : ''}
                                onChange={(e:any) => { 
                                    e.target.value = e.target.value.replace(',','.')
                                    props.change(e)
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className='modal-footer'>
                            <Button 
                                className='btn' 
                                color='secondary'
                                variant='contained'
                                onClick={() => props.hide()}>
                                Abbrechen
                            </Button>
                            <Button 
                                className='btnBlue' 
                                color='primary'
                                variant='contained'
                                onClick={() => props.submit()}>
                                Hinzufügen
                            </Button>
                        </div>
            </div>
        </div>
    </div>
    )
}

export default withModal(AddCostModal)